import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import {
  updateLayoutNesting,
  UpdateLayoutNestingRequestBody,
  UpdateLayoutNestingResponse,
} from "#modules/layouts/infra/updateLayoutNesting.api";

import { layoutQuery } from "../infra/layout.query";

type Params = {
  onSuccess?: (data: UpdateLayoutNestingResponse) => void;
  onError?: (err: unknown) => void;
};

export const useUpdateLayoutNesting = (layoutId: string | null | undefined, options?: Params) => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation<
    UpdateLayoutNestingResponse,
    Error,
    UpdateLayoutNestingRequestBody
  >({
    mutationFn: (body: UpdateLayoutNestingRequestBody) => {
      if (!layoutId) {
        throw new Error("Layout ID is required");
      }
      return updateLayoutNesting(layoutId, body);
    },
    onSuccess: async (data) => {
      await queryClient.invalidateQueries(layoutQuery(layoutId));
      options?.onSuccess?.(data);
    },
    onError: (err: unknown) => {
      options?.onError?.(err);
      errorHandler(err);
    },
  });

  return { updateLayoutNesting: mutate, ...rest };
};
